import type { Board } from "../board";
import { DestroyableObstacle } from "../destroyableObstacle";
import { type Interactable, PRIORITY_DEFAULT, type ProcessableThing } from "../interfaces";
import type { SimpleBoard } from "../levelgenerator/simpleBoard";
import { ParticleType } from "../particleType";
import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import { Strings } from "../strings/strings";
import type { XY } from "../xy";

export class Sign extends DestroyableObstacle implements ProcessableThing, Interactable {
	static key = "Sign";
	private textKey: string;

	constructor(xy: XY, textKey: string = "sign_default") {
		super(xy);
		this.textKey = textKey;
	}

	getTextKey(): string {
		return this.textKey;
	}

	getDebrisParticleType(): ParticleType {
		return ParticleType.WOOD_DEBRIS;
	}

	canInteract(): boolean {
		return true;
	}

	interact(_player: PhysicalThing): void {
		const text = Strings.get(this.textKey) ?? this.textKey;
		this.board!.requestShowSignText(this.xy, text);
	}

	processTurn(board: Board): void {
		const player = board.player;
		if (!player) return;
		if (!this.xy.isInSquareRadius(player.xy, 1)) return;
		const text = Strings.get("prompt_readSign") ?? "prompt_readSign";
		board.emitPrompt(text);
	}

	getProcessPriority(): number {
		return PRIORITY_DEFAULT;
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), textKey: this.textKey };
	}

	static deserialize(data: any): Sign {
		const s = new Sign(deserializeXY(data.xy), data.textKey ?? "sign_default");
		s.restoreBaseFields(data);
		return s;
	}

	static override initOnBoard(xy: XY, board: SimpleBoard, props?: Record<string, unknown>): PhysicalThing[] {
		const textKey = typeof props?.textKey === "string" ? props.textKey : "sign_default";
		const sign = new Sign(xy, textKey);
		board.putThing(sign);
		return [sign];
	}
}
